var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRenzo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 29,
    viewBox: "0 0 121 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37_35",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 121,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M121 0H0V29H121V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37_35)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5858 14.5457C19.5352 13.1287 20.0099 11.5281 20.0099 9.79629C20.0099 8.22189 19.6144 6.77878 18.8496 5.44058C18.0584 4.10238 17.0035 3.05278 15.6585 2.26558C14.3135 1.50468 12.8367 1.11108 11.2807 1.11108H0.0458984V4.78458H11.2807C12.6784 4.78458 13.8652 5.28308 14.8673 6.25398C15.8431 7.22488 16.3442 8.40568 16.3442 9.82258C16.3442 11.2395 15.8431 12.394 14.8673 13.3912C13.8915 14.362 12.7048 14.8605 11.2807 14.8605H0.0458984V27.6916H3.7381V18.534H11.2807C11.307 18.534 11.3598 18.534 11.4125 18.534C11.4652 18.534 11.518 18.534 11.5443 18.534L16.3442 27.7179H20.0363L14.841 17.7731C16.3969 17.0384 17.6364 15.9888 18.5858 14.5457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9657 12.5777V16.2513H42.7693V12.5777H23.9657ZM23.9657 24.123L22.0405 27.7179H42.7957V24.123H23.9657ZM22.0405 1.11108L23.9657 4.78458H42.7693V1.11108H22.0405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.3447 1.11089V20.2919L45.5649 0.00878906V27.7439H49.257V8.82519L69.0367 28.9509V1.11089H65.3447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.2687 17.9043L85.8357 14.0471C87.5237 13.05 88.8687 11.7118 89.8447 10.0062C90.8207 8.30069 91.2947 6.46389 91.2947 4.49599V1.11108H72.0957V4.78458H87.6297V4.83708C87.6297 6.09658 87.3127 7.27728 86.6797 8.37938C86.0467 9.48149 85.1767 10.3473 84.0957 10.9771L77.6077 14.7818C75.8937 15.7789 74.5747 17.1171 73.5727 18.8227C72.5967 20.5282 72.0957 22.365 72.0957 24.3329V27.6916H91.2947V24.0181H75.7617C75.7617 22.7586 76.0777 21.5779 76.7107 20.502C77.3177 19.4 78.1877 18.534 79.2687 17.9043Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.964 15.5688C120.964 15.595 120.964 15.6213 120.964 15.6475C120.384 22.05 115.267 27.0616 109.017 27.6914C108.965 27.6914 108.939 27.6914 108.886 27.6914L120.964 15.5688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.448 2.31777C113.105 2.16037 112.762 2.00297 112.42 1.87177C111.734 1.60937 111.022 1.39947 110.283 1.24197C109.387 1.05827 108.49 0.953369 107.54 0.953369C107.092 0.953369 106.644 0.979569 106.196 1.00587C103.084 1.32067 100.314 2.65897 98.179 4.70557C98.046 4.83677 97.888 4.99427 97.756 5.12547C95.726 7.25087 94.407 10.0585 94.117 13.1285C94.091 13.5221 94.064 13.9157 94.064 14.3355C94.064 15.3326 94.17 16.3034 94.381 17.248C94.539 17.9566 94.75 18.6388 95.013 19.321C95.172 19.6883 95.33 20.0557 95.488 20.3968C95.805 21.0003 96.148 21.5776 96.543 22.1286L98.758 19.8982L113 5.57147L115.215 3.34117C114.688 2.97377 114.081 2.63267 113.448 2.31777ZM97.467 16.8807C97.44 16.802 97.414 16.697 97.414 16.6183C97.255 15.8836 97.177 15.1226 97.177 14.3617C97.177 11.7115 98.179 9.21877 99.998 7.30327L100.367 6.93597C102.319 5.07297 104.851 4.04957 107.567 4.04957C108.279 4.04957 108.991 4.12837 109.677 4.25947C109.782 4.28577 109.888 4.31197 109.994 4.33827L97.467 16.8807Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.899 26.9567C102.556 26.8255 102.24 26.6943 101.924 26.5631C101.264 26.2482 100.631 25.9071 100.024 25.4873L118.644 6.77856C119.039 7.35586 119.408 7.95926 119.699 8.61536C119.856 8.95646 120.015 9.29756 120.147 9.63866L102.899 26.9567Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRenzo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/renzo.656ba1c679e3a9d0872013ec05c71305.svg";